module.exports = __webpack_public_path__ + "img/threat-analytics-alerts-details.629af46e.png";